import { useObjectGet } from '../api/object'

export function LocationFormatter({ id }: { id?: string | null }) {
	const { data: location } = useObjectGet('location', id)

	if (!id) return <em className="text-gray-400">nevyplněno</em>

	return <>{location?.name}</>
}
